import styled from 'styled-components';

import DocHierarchy from '../DocHierarchy/DocHierarchy';

export const StyledDocHierarchy = styled(DocHierarchy)`
  padding: 16px;
  width: 581px;
  max-height: 416px;
`;
